import React from 'react';
import {Accordion, AccordionBody, AccordionHeader, Icon, Loading, Toast} from "spectre-react/dist/cjs";
import {URL_FETCH_WAGES_PARAMS_ALL, URL_DELETE_NEXT_WAGES_PARAMS} from "../api";
import { useFetch } from '../hooks';
import ErrorToast from "./shared/ErrorToast";


const WagesParamsHistoryPage = () => {
    const [
        { isLoading: isLoadingDocs, response: docs, error: fetchError, errorReason: fetchErrorReason },
        { doFetch: fetchDocs }
    ] = useFetch(URL_FETCH_WAGES_PARAMS_ALL, { now: true });

    const [
        { isLoading: isDeleting, error: deleteError, errorReason: deleteErrorReason },
        { doFetch: deleteNextDoc, clearError: clearDeleteError }
    ] = useFetch(URL_DELETE_NEXT_WAGES_PARAMS);

    const handleDelete = async () => {
        if (!window.confirm('Точно удалить?')) return;

        await deleteNextDoc({ method: 'DELETE' });
        await fetchDocs({ method: 'GET' });
    };

    if (fetchError) return <ErrorToast>{fetchErrorReason}</ErrorToast>;
    if (isLoadingDocs || !docs) return <Loading large />;

    return (
        <div className="container grid-xl" id="wages-params-history-page">
            <h1>История коэффициентов для расчета оплаты труда</h1>
            {docs.map((doc, index) => (
                <Accordion key={index} open={index === 0}>
                    <AccordionHeader className="mb-2 mt-4 c-hand">
                        <Icon icon="arrow-right" className="mr-1" />
                        {doc.startDate} — {doc.endDate ?? 'и до скончания времен'}
                    </AccordionHeader>
                    <AccordionBody>
                        {doc.isNext && (
                            <div className="mb-2">
                                Поскольку эти коэффициенты еще не начали действовать, их можно{" "}
                                <span className="c-hand text-bold text-primary" onClick={isDeleting ? undefined : handleDelete}>удалить</span>.
                                {deleteError && <ErrorToast className="mt-2" onButtonClick={clearDeleteError}>{deleteErrorReason}</ErrorToast>}
                            </div>
                        )}
                        <textarea className="form-input"
                                  defaultValue={JSON.stringify(doc.params, null, 4)}
                                  rows={20}
                                  readOnly
                        />
                    </AccordionBody>
                </Accordion>
            ))}
        </div>
    );
};


export default WagesParamsHistoryPage;